import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { APP_PATH_EDITOR_COMPANY } from '../../../../config';
import { withRouter } from 'react-router-dom';

const useStyle = makeStyles((theme) => ({
  companyName: {
    marginBottom: '10px',
    marginTop: '10px',
    textAlign: 'center',
    color: theme.palette.text.primary,
    transition: 'all 0.3s ease'
  },
  logo: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    transition: 'transform 0.3s ease'
  },
  companyLink: {
    lineHeight: '30px'
  },
  applyBtn: {
    textTransform: 'none',
    fontSize: '20px'
  },
  companyInfoCard: {
    cursor: 'pointer',
    padding: theme.spacing(1),
    '&:hover': {
      '& $logo': {
        transform: 'scale(1.1)'
      },
      '& $companyName': {
        color: theme.palette.text.primary,
        opacity: 0.9
      }
    }
  }
}));

const CompanyInfo = ({
  name,
  fileLogoUrl,
  history,
  onClickInfo,
  companyInfo
}) => {
  const classes = useStyle();
  return (
    <Grid
      className={classes.companyInfoCard}
      onClick={() => {
        onClickInfo(companyInfo);
        history.push(APP_PATH_EDITOR_COMPANY);
      }}
      alignItems="center"
      container
      direction="column"
      justifyContent="flex-start">
      <Grid item>
        <Avatar className={classes.logo} src={fileLogoUrl || ''} />
      </Grid>
      <Grid item>
        <Typography className={classes.companyName} variant="h4">
          {name}
        </Typography>
      </Grid>
    </Grid>
  );
};

CompanyInfo.defaultProps = {
  name: '',
  fileLogoUrl: '',
  companyInfo: null
};

CompanyInfo.propTypes = {
  companyInfo: PropTypes.object,
  name: PropTypes.string,
  fileLogoUrl: PropTypes.string,
  history: PropTypes.object.isRequired,
  onClickInfo: PropTypes.func.isRequired
};
export default withRouter(CompanyInfo);
